/* eslint-disable import/prefer-default-export */
import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getSuggestedUserList } from 'features/suggestedUsers/asyncThunks'
import { useAccountId } from 'hooks/usePageConfig'
import { selectV4ScheduledReportInfo } from 'features/scheduledReport/selectors'
import { ScheduledReport } from 'features/scheduledReport/types'
import { selectCurrentUser, selectSubscriptionUsers } from 'features/suggestedUsers/selectors'
import AlertDayOfMonth from 'enums/AlertDayOfMonth'
import AlertDayOfWeek from 'enums/AlertDayOfWeek'

import { FREQUENCY_OFF } from './utils'

export const useRetrieveScheduledReportInfos = () => {
  const dispatch = useAppDispatch()
  const accountId = useAccountId()
  const scheduledReportInfo = useAppSelector(selectV4ScheduledReportInfo)
  const isLoading = useAppSelector(
    (state) =>
      state.scheduledReport.reportInfo.status === 'loading' ||
      state.suggestedUserList.status === 'loading'
  )
  const isSaving = useAppSelector(
    (state) => state.scheduledReport.savingInfo.saveStatus === 'loading'
  )
  const currentUser = useAppSelector(selectCurrentUser)
  const subscriptionUsers = useAppSelector(selectSubscriptionUsers)

  useEffect(() => {
    dispatch(getSuggestedUserList(accountId!))
  }, [dispatch, accountId])

  const defaultScheduledReportInfo = useMemo<ScheduledReport>(() => {
    if (!scheduledReportInfo) {
      return {
        frequency: FREQUENCY_OFF,
        colorMode: 'LIGHT',
        alertHourFirst: 0,
        alertHourSecond: 0,
        dayOfWeek: AlertDayOfWeek.MONDAY,
        dayOfMonth: AlertDayOfMonth.FIRST,
        subscriptions: [] as { subscriberId: string }[]
      }
    }
    return {
      ...scheduledReportInfo,
      colorMode: scheduledReportInfo?.colorMode ?? 'LIGHT',
      subscriptions: scheduledReportInfo?.subscriptions?.map((subscription) => ({
        subscriberId: subscription.subscriberId
      }))
    }
  }, [scheduledReportInfo])

  const defaultSubscribers = useMemo(() => {
    const defaultSubscriber = currentUser ? [currentUser] : []
    if (scheduledReportInfo === undefined) {
      return defaultSubscriber
    }
    return subscriptionUsers
  }, [currentUser, scheduledReportInfo, subscriptionUsers])

  return { defaultScheduledReportInfo, defaultSubscribers, isLoading, isSaving }
}
